module.exports = __webpack_public_path__ + "static/img/icon13.dfecb29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon13.png
// module id = CuKG
// module chunks = 1